var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-0"},[(_vm.isPartnerHost)?[_c('LoginPartner')]:(_vm.hostname.includes('myboardpage'))?[_c('LoginBoard')]:[_c('LoginExisting')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }